export const userDetailsReducer = (state, action) => {
  switch (action.type) {
    case "USER_DETAILS_UPDATE":
      const { name, value } = action.payload;
      const newState = { ...state, [name]: value };
      return newState;
    case "USER_DETAILS_RESET":
      const initialUserState = {
        sfdcId: "",
        username: "",
        email: "",
        phone: "",
      };
      return initialUserState;
    default:
      return state;
  }
};
